import Grid from '@/docs-partials/sdk/grid.mdx';
import * as React from 'react';
export default {
  Grid,
  React
};